import { MDBAlert, MDBDatatable, MDBIcon, MDBModalFooter, MDBBtn, MDBToast, MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from "react";
import { browserName, browserVersion } from "react-device-detect";
import { useNavigate } from "react-router";
import Header from "../components/Header";
import LeftPane from "../components/LeftPane";
import {
  deleteAddon,
  deletePlan,
  deleteSlot,
  getDiscount,
  getGymAddonsList,
  getPlans,
  getSlots,
  saveImportedSlot,
  saveImportedAddon,
  saveImportedPlan,
  getPricingPlansById
} from "../services/apiServices";
import { deleteDiscount, logEvent } from "../services/apiServices.js";

import {
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane
} from 'mdb-react-ui-kit';


import Popup from "../components/Popup";
import Toast from "../components/Toast";
import CreateAddon from "./CreateAddon";
import CreateDiscount from "./CreateDiscount";
import CreateSlot from "./CreateSlot";
import PlansHeader from "./PlansHeader";
import CreatePlan from "./createPlan";
import PageError from './PageError';
import ExcelJS from 'exceljs';
import ImportExcelModal from "../components/ImportExcelModal"
import VaritationPlan from './VaritationPlans';
import { BasePlanName } from '../utils/BasePlanName';
import { useAnalytics } from "../hooks/useAnalytics";
import { useAccess } from '../context/AccessContext';


const PlansAndAddons = () => {
  const [discount, setDiscount] = useState([])
  const [plans, setPlans] = useState([]);
  const { trackButtonClick } = useAnalytics();
  const [editId, setEditId] = useState(null);
  const [planupdate, setPlanupdate] = useState(false);
  const [slotupdate, setSlotupdate] = useState(false);
  const [addonupdate, setAddonupdate] = useState(false);
  const [createDiscount, setcreateDiscount] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [smessage, setSMessage] = useState(null);
  const [addons, setAddons] = useState([]);
  const [slots, setSlots] = useState([]);
  const navigate = useNavigate();
  const [Alerttxt, setAlerttxt] = useState("");
  const [Alerttxtt, setAlerttxtt] = useState("");
  const [Error2, setError2] = useState("")
  const [mfilter, setMfilter] = useState({
    ptoggle: "",
    pType: "",
    atoggle: "",

  });
  const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
  const isAdmin = loggedUserInfo?.role !== "staff";
  const [importPopUp, setImportPopUp] = useState(false);
  const [slotErrorMessage, setSlotErrorMessage] = useState("");
  const [importedSlotData, setImportedSlotData] = useState([]);
  const [importSlotError, setImportSlotError] = useState("");


  const [importPlanPopUp, setImportPlanPopUp] = useState(false);
  const [planErrorMessage, setPlanErrorMessage] = useState("");
  const [importedPlanData, setImportedPlanData] = useState([]);
  const [importPlanError, setImportPlanError] = useState("");
  const [reupdate, setReupdate] = useState(false);
  const [importAddonPopUp, setImportAddonPopUp] = useState(false);
  const [AddonerrorMessage, setAddonErrorMessage] = useState("");
  const [importedAddonData, setImportedAddonData] = useState([]);
  const [importAddonError, setImportAddonError] = useState("");
  const [plansInfo, setPlanInfo] = useState(JSON.parse(localStorage.getItem("planInfo")))
  // useEffect(() => {
  //   setPlanInfo(JSON.parse(localStorage.getItem("planInfo")));
  // }, [localStorage.getItem("planInfo")])

  const [showVariationPlan, setShowVariationPlan] = useState(false);
  const [variationData, setVariationData] = useState(null);

  const [baseplanId, setBaseplanId] = useState("")
  const [parentData, setParentDate] = useState()
  const [data, setData] = useState("")
  const { handlePageAccess } = useAccess();
  const roleAccess = handlePageAccess("membership")

  const handleBackToCreatePlan = (subplanData) => {
    setData(subplanData);
    setShowVariationPlan(false);
  };


  const tooglePlanPopup = () => {
    setImportPlanPopUp(true);
  }


  const tooglePlanClose = () => {
    setPlanErrorMessage("");
    setImportPlanPopUp(false);
  }


  const toogleAddonPopup = () => {
    setImportAddonPopUp(true);
  }

  const toogleAddonClose = () => {
    setAddonErrorMessage("");
    setImportAddonPopUp(false);
  }

  const toggleModal = () => {
    setImportPopUp(true);
    console.log("pop up trigred")

  }

  const popUpClose = () => {
    setSlotErrorMessage("");
    setImportPopUp(false);
  }

  const handleSamplePlanDownload = () => {
    const sampleData = [
      {
        name: "Day",
        description: "",
        discount: "10",
        enable: "Enabled",
        numberofdays: 1,
        pdays: "All",
        price: 750,
        pslots: "Evening Slot",
        ptype: "One-time",
        sessionvalue: 1,
        taxcheck: "Included",
        validityflag: "Days"
      },
      {
        name: "Weekly",
        description: "",
        discount: "15",
        enable: "Enabled",
        numberofdays: 7,
        pdays: "Monday, Tuesday",
        price: 5000,
        pslots: "Morning Slot",
        ptype: "Recurring",
        sessionvalue: 20,
        taxcheck: "Included",
        validityflag: "Days"
      },
    ];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sample Plan Data");

    worksheet.columns = [
      { header: "Plan Name", key: "name", width: 20 },
      { header: "Validity", key: "numberofdays", width: 15 },
      { header: "Valid Type", key: "validityflag", width: 20 },
      { header: "Session(s)", key: "sessionvalue", width: 15 },
      { header: "Discount (%)", key: "discount", width: 15 },
      { header: "Valid Days", key: "pdays", width: 20 },
      { header: "Allowed Slot", key: "pslots", width: 30 },
      { header: "Plan Type", key: "ptype", width: 15 },
      { header: "Price", key: "price", width: 15 },
      { header: "Tax", key: "taxcheck", width: 15 },
      { header: "Enable/Disable	", key: "enable", width: 10 },
      { header: "Description", key: "description", width: 30 },
    ];


    sampleData.forEach((data) => {
      worksheet.addRow(data);
    });


    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Sample_Plan_Data.xlsx";
      link.click();
    });
  };
  const importPlanExcelSheet = async (file) => {
    if (!file) {
      console.error("No file selected");

      return;
    }

    const workbook = new ExcelJS.Workbook();
    const reader = new FileReader();

    reader.onload = async () => {
      const buffer = reader.result;
      await workbook.xlsx.load(buffer);
      const worksheet = workbook.getWorksheet(1);

      const importedData = [];
      const validationErrors = [];
      const headers = {};

      worksheet.getRow(1).eachCell((cell, colNumber) => {
        try {
          if (cell.value) {
            headers[cell.value.trim()] = colNumber;
          }
        } catch (error) {
          console.log(error);
        }
      });

      const parseValidDays = (value) => {
        const dayMapping = {
          Sun: 1, Sunday: 1,
          Mon: 2, Monday: 2,
          Tue: 3, Tuesday: 3,
          Wed: 4, Wednesday: 4,
          Thu: 5, Thursday: 5,
          Fri: 6, Friday: 6,
          Sat: 7, Saturday: 7,

        };


        if (typeof value !== "string") return [];

        const trimmedValue = value.trim().toUpperCase();

        if (trimmedValue === "ALL") {
          return [1, 2, 3, 4, 5, 6, 7].map((day) => ({ day }));
        }

        return value
          .split(",")
          .map((day) => {
            const trimmedDay = day.trim();
            const normalizedDay =
              trimmedDay.charAt(0).toUpperCase() + trimmedDay.slice(1).toLowerCase();
            const mappedDay = dayMapping[normalizedDay];

            if (!mappedDay) {
              console.warn("Unmapped day:", trimmedDay);
            }

            return mappedDay ? { day: mappedDay } : null;
          })
          .filter((day) => day !== null);
      };

      // const mapDiscount = (value) => {
      //   if (value == null) return 0;

      //   const normalizedValue = String(value).trim().replace("%", "");
      //   console.log(normalizedValue, "Mapped Discount Value");

      //   switch (normalizedValue) {
      //     case "0":
      //       return 0;
      //     case "5":
      //       return 1;
      //     case "10":
      //       return 2;
      //     case "15":
      //       return 3;
      //     case "50":
      //       return 4;
      //     default:
      //       console.warn("Unmapped discount value:", value);
      //       return 0;
      //   }
      // };
      const mapDiscount = (value) => {
        if (value == null) return 0;

        const normalizedValue = String(value).trim().replace("%", "");

        if (!/^\d+(\.\d+)?$/.test(normalizedValue)) {
          console.warn("Invalid discount format:", value);
          return -1; // Invalid value for validation check
        }

        const numericDiscount = parseFloat(normalizedValue);

        if (numericDiscount < 0 || numericDiscount > 100) {
          console.warn("Discount out of allowed range (0-100):", numericDiscount);
          return -1; // Invalid value
        }

        switch (String(Math.round(numericDiscount))) {
          case "0": return 0;
          case "5": return 1;
          case "10": return 2;
          case "15": return 3;
          case "50": return 4;
          case "100": return 5;
          default:
            console.warn(`Discount ${numericDiscount}% is not a standard value. Allowed: 0, 5, 10, 15, 50, 100`);
            return -1;
        }
      };



      // const parseSlots = (value) => {
      //   if (!value || typeof value !== "string") return [];

      //   return value
      //     .split(",")
      //     .map((slot) => {
      //       const trimmedSlot = slot.trim().replace(/\s+/g, " ");
      //       return trimmedSlot ? { slot: trimmedSlot, trimmedSlot } : null;
      //     })
      //     .filter((slot) => slot !== null);
      // };


      const parseSlots = (value) => {
        if (!value || typeof value !== "string") return [];

        // Special case for "All"
        if (value.trim().toUpperCase() === "ALL") {
          return [{ slot: "ALL", trimmedSlot: "ALL" }];
        }

        // Split by comma and process each slot
        return value
          .split(",")
          .map((slot) => {
            const trimmedSlot = slot.trim().replace(/\s+/g, " ");
            return trimmedSlot ? { slot: trimmedSlot, trimmedSlot } : null;
          })
          .filter((slot) => slot !== null);
      };

      const mapEnable = (value) => {
        if (typeof value !== "string" || value.trim() === "") {
          return null;
        }

        const normalizedValue = value.trim().toLowerCase();
        if (normalizedValue === "enable" || normalizedValue === "enabled") {
          return true;
        } else if (normalizedValue === "disable" || normalizedValue === "disabled") {
          return false;
        }

        return null;
      };

      const mapTax = (value) => {
        if (typeof value === "string") {
          const normalizedValue = value.trim().toLowerCase();
          if (normalizedValue === "included") return true;
          if (normalizedValue === "excluded") return false;
        }
        return null;
      };
      const mapPlanType = (value) => {
        if (typeof value === "string") {
          const trimmedValue = value.trim();
          return trimmedValue;
        }
        return null;
      };
      const capitalizeFirstLetter = (str) => {
        if (!str) return "";
        str = str.toString().trim().toLowerCase();
        return str.charAt(0).toUpperCase() + str.slice(1);
      };

      const isValidString = (value) => typeof value === "string" && value.trim().length > 0;
      const isValidNumber = (value) => !isNaN(value) && value !== null && value !== undefined && value >= 0;

      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1 && row.hasValues) {
          const transformedRow = {
            name: headers["Plan Name"]
              ? capitalizeFirstLetter(row.getCell(headers["Plan Name"])?.value) || ""
              : "",
            numberofdays: headers["Validity"]
              ? parseInt(row.getCell(headers["Validity"])?.value) || 0
              : 0,
            sessionvalue: headers["Session(s)"]
              ? parseInt(row.getCell(headers["Session(s)"])?.value) || 0
              : 0,
            discount: headers["Discount (%)"]
              ? mapDiscount(row.getCell(headers["Discount (%)"])?.value || "0")
              : 0,
            pdays: headers["Valid Days"]
              ? parseValidDays(row.getCell(headers["Valid Days"])?.value || "")
              : [],
            validityflag: headers["Valid Type"]
              ? (row.getCell(headers["Valid Type"])?.value)
              : null,
            pslots: headers["Allowed Slot"]
              ? parseSlots(row.getCell(headers["Allowed Slot"]).value || "")
              : [],

            ptype: headers["Plan Type"]
              ? capitalizeFirstLetter(mapPlanType(row.getCell(headers["Plan Type"])?.value))
              : null,
            price: headers["Price"]
              ? parseFloat(row.getCell(headers["Price"])?.value) || 0
              : 0,
            taxcheck: headers["Tax"]
              ? mapTax(row.getCell(headers["Tax"])?.value)
              : false,
            enable: headers["Enable/Disable"]
              ? mapEnable(row.getCell(headers["Enable/Disable"])?.value)
              : true,
            description: headers["Description"]
              ? row.getCell(headers["Description"])?.value || ""
              : "",
          };


          let errors = [];

          if (!isValidString(transformedRow.name)) errors.push("Plan Name is required.");
          if (!isValidNumber(transformedRow.numberofdays) || transformedRow.numberofdays <= 0) errors.push("Validity (Number of days) must be a positive number.");
          if (!isValidNumber(transformedRow.price) || transformedRow.price <= 0) errors.push("Price must be a positive number.");
          if (!isValidNumber(transformedRow.sessionvalue) || transformedRow.sessionvalue < 0) errors.push("Session value cannot be negative.");
          // if (!isValidNumber(transformedRow.discount) || transformedRow.discount <= 0) errors.push("Discount must be a positive number. Discount must be between 0 and 100.")
          if (transformedRow.pdays.length === 0) errors.push("Valid Days must be provided.");
          if (!Array.isArray(transformedRow.pslots) || transformedRow.pslots.length === 0) {
            errors.push("Allowed Slot must be provided.");
          }
          if (transformedRow.taxcheck === null) errors.push("Tax must be either 'Included' or 'Excluded'.");
          if (transformedRow.enable === null) errors.push("Enable/Disable status must be 'Enable' or 'Disable'.");

          if (!["One-time", "Recurring"].includes(transformedRow.ptype)) errors.push("Plan Type must be 'One-time' or 'Recurring'.");
          if (!["Days", "Months", "Years"].includes(transformedRow.validityflag)) errors.push("Valid Type must be 'Days', 'Months', or 'Years'.");
          if (transformedRow.discount === -1) {
            errors.push("Discount must be a valid number between 0 and 100.");
          }

          // if (transformedRow.sessionvalue < 0) errors.push("Session value cannot be negative.");

          if (errors.length > 0) {
            validationErrors.push({ row: rowNumber, issues: errors });
          } else {
            importedData.push(transformedRow);
          }
        }
      });


      let requestData = {
        gymId: localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "",
      };


      if (validationErrors.length > 0) {
        console.error("Validation Errors:", validationErrors);

        // requestData.status = "failed";
        // requestData.errors = validationErrors;
        setPlanErrorMessage(validationErrors.map(e => `Row ${e.row}: ${e.issues.join(", ")}`).join("\n"));
        setTimeout(() => {
          setImportPlanPopUp(false);
          setPlanErrorMessage("");
        }, 20000);

        // await saveImportedPlan(requestData, localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "");
        return;
      }


      // setImportedPlanData(importedData);

      if (importedData.length === 0) {
        setImportPlanError("The file is empty or does not contain valid Plan data.");
        setImportPlanPopUp(false);
        return;
      } else {
        setImportPlanError("");
      }
      console.log("Imported Data:", importedData);

      try {
        console.log("Data for Backend:", importedData);
        if (plansInfo != null && plansInfo?.limitation && plansInfo?.limitation?.memebershipplans != -1) {
          if ((plans.length + importedData.length) > plansInfo?.limitation?.memebershipplans) {
            setAlerttxt("Your imported data exceeds the allowed limit. Please upgrade your plan for higher capacity.");
            return;
          }
        }
        if (
          plansInfo?.feature?.planswithsessionslimit === false &&
          !importedData.every(obj => obj.sessionvalue === 0)
        ) {
          setAlerttxt("Your imported data exceeds your current plan's session limit. Please upgrade your plan for more capacity.");
          return;
        }

        requestData.status = "success";
        requestData.data = importedData;
        let response = await saveImportedPlan(requestData, localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "");
        console.log("responseresponseresponse", response)
        if (!response) {
          return;
        }
        if (response === "false") {
          setApiError(true)
        }
        else {
          const result = await response.json();
          console.log("Backend Response:", result);
          if (result.message == "Success") {
            setAlerttxtt("Plan(s) Imported successfully!");
            setPlanErrorMessage("");
            setImportPlanPopUp(false);
            await trackButtonClick("PlansAndAddons", "Plan_Import", "staff", {});

          }
          else {
            setError2("Failed to Import Plan(s)");

            setPlanErrorMessage(result?.message);
            setTimeout(() => {
              setImportPlanPopUp(false);
              setPlanErrorMessage("");
            }, 20000);
          }

        }
      } catch (error) {
        console.error("Error during import:", error.message);

        requestData.status = "failed";
        requestData.errors = [{ error: error.message }];

        await saveImportedPlan(requestData);
        setPlanErrorMessage(error.message);

      }

    };

    reader.readAsArrayBuffer(file);
  };




  const importAddonExcelSheet = async (file) => {

    if (!file) {
      console.error("No file selected");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const reader = new FileReader();

    reader.onload = async () => {
      const buffer = reader.result;
      await workbook.xlsx.load(buffer);
      const worksheet = workbook.getWorksheet(1);

      const importedData = [];
      const validationErrors = [];

      const headers = {};
      worksheet.getRow(1).eachCell((cell, colNumber) => {
        if (cell.value) {
          headers[cell.value] = colNumber;
        }
      });


      const mapEnabled = (value) => {
        if (typeof value === "string") {
          const normalizedValue = value.trim().toLowerCase();
          if (normalizedValue === "enabled") return "Enabled";
          if (normalizedValue === "disabled") return "Disabled";
        }
        return null;
      };
      const mapTax = (value) => {
        if (typeof value === "string") {
          const normalizedValue = value.trim().toLowerCase();
          if (normalizedValue === "include") return "Include";
          if (normalizedValue === "exclude") return "Exclude";
        }
        return null;
      };
      const mapRentBasis = (value) => {
        if (typeof value === "string") {
          const normalizedValue = value.trim();
          if (normalizedValue === "Monthly") return "Monthly";
          if (normalizedValue === "Daily") return "Daily";
          if (normalizedValue === "Yearly") return "Yearly";
        }
        return null;
      };

      const capitalizeFirstLetter = (str) => {
        if (!str) return "";
        str = str.toString().trim().toLowerCase();
        return str.charAt(0).toUpperCase() + str.slice(1);
      };


      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1 && row.hasValues) {
          const transformedRow = {
            description: headers["Description"]
              ? row.getCell(headers["Description"])?.value || ""
              : "",
            enable: headers["Enable/Disabled"]
              ? mapEnabled(row.getCell(headers["Enable/Disabled"])?.value)
              : false,
            name: headers["Add-on Name"]
              ? row.getCell(headers["Add-on Name"])?.value || ""
              : "",
            rentbasis: headers["Validity"]
              ? mapRentBasis(row.getCell(headers["Validity"])?.value)
              : null,
            taxcheck: headers["Tax"]
              ? mapTax(row.getCell(headers["Tax"])?.value)
              : false,
            props: headers["Price"]
              ? [{ propvalue: row.getCell(headers["Price"])?.value || "" }]
              : [],
          };

          const errors = validateRow(transformedRow, rowNumber);
          if (errors.length > 0) {
            validationErrors.push({ row: rowNumber, errors });
          } else {
            importedData.push(transformedRow);
          }
        }
      });


      let requestData = {
        gymId: localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "",
      };

      if (validationErrors.length > 0) {
        console.error("Validation Errors:", validationErrors);

        requestData.status = "failed";
        requestData.errors = validationErrors;
        setAddonErrorMessage(validationErrors.map(e => `Row ${e.row}: ${e.errors.join(", ")}`).join("\n"));
        setTimeout(() => {
          setImportAddonPopUp(false);
          setAddonErrorMessage("");
        }, 20000);
        // await saveImportedAddon(requestData);


        return;
      }



      console.log("Imported Data:", importedData);

      // setImportedAddonData(importedData);

      if (importedData.length === 0) {
        setImportAddonError("The file is empty or does not contain valid Addon data.");
        setImportAddonPopUp(false);
        return;
      } else {
        setImportAddonError("");
      }

      try {
        console.log("Data for Backend:", importedData);

        requestData.status = "success";
        requestData.data = importedData;
        if (plansInfo != null && plansInfo?.limitation && plansInfo?.limitation?.addons != -1) {
          if ((addons.length + importedData.length) > plansInfo?.limitation?.addons) {
            setAlerttxt("Your imported data exceeds the allowed limit. Please upgrade your plan for higher capacity.");
            return;
          }
        }
        let response = await saveImportedAddon(requestData);


        if (!response) {
          return;
        }
        if (response === "false") {
          setApiError(true)
        }
        else {
          const result = await response.json();
          console.log("Backend Response:", result);
          if (result.message == "Success") {
            setAlerttxtt("Addon(s) Imported successfully!");
            await trackButtonClick("PlansAndAddons", "Addon_Import", "staff", {});

          }
          else {
            setError2("Failed to Import Addon(s)");
          }
          setImportAddonPopUp(false);
        }
      } catch (error) {
        console.error("Error during import:", error.message);

        requestData.status = "failed";
        requestData.errors = [{ error: error.message }];

        await saveImportedAddon(requestData);

      }
    };

    reader.readAsArrayBuffer(file);
  };

  const validateRow = (row, rowNumber) => {
    const errors = [];

    if (!row.name) errors.push("Add-on Name is required.");
    if (!row.rentbasis) errors.push("Validity is required.");
    if (!row.props || !row.props[0]?.propvalue) {
      errors.push("Price is required.");
    }
    if (row.taxcheck !== "Include" && row.taxcheck !== "Exclude") {
      errors.push("Tax must be 'Include' or 'Exclude'.");
    }
    if (row.enable !== "Enabled" && row.enable !== "Disabled") {
      errors.push("Enable status must be 'Enabled' or 'Disabled'.");
    }
    // if (!row.description) errors.push("Description is required.");
    if (!["Daily", "Monthly", "Yearly"].includes(row.rentbasis)) {
      errors.push("Validity must be 'Daily', 'Monthly', or 'Yearly'.");
    }
    if (row.props && row.props[0]?.propvalue && (isNaN(row.props[0].propvalue) || row.props[0].propvalue <= 0)) {
      errors.push("Price must be a positive number.");
    }

    return errors;
  };



  const handleSampAddonDownload = () => {
    const sampleData = [
      {
        name: "Gloves",
        rentbasis: "Daily",
        propvalue: "500",
        taxcheck: "Include",
        enable: "Enabled",
        description: "You can add Description of Addon",
      },
      {
        name: "Yoga Mats",
        rentbasis: "Yearly",
        propvalue: "800",
        taxcheck: "Include",
        enable: "Enabled",
        description: "You can add Description of Addon",
      },
      {
        name: "Resistance Bands",
        rentbasis: "Monthly",
        propvalue: "1500",
        taxcheck: "Exclude",
        enable: "Disabled",
        description: "You can add Description of Addon",
      },
    ];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sample Data");


    worksheet.columns = [

      { header: "Add-on Name", key: "name", width: 15 },
      { header: "Validity", key: "rentbasis", width: 15 },
      { header: "Price", key: "propvalue", width: 20 },
      { header: "Tax", key: "taxcheck", width: 10 },
      { header: "Enable/Disabled", key: "enable", width: 10 },
      { header: "Description", key: "description", width: 25 },
    ];


    sampleData.forEach((data) => {

      worksheet.addRow({
        enable: data.enable,
        name: data.name,
        rentbasis: data.rentbasis,
        taxcheck: data.taxcheck,
        propvalue: data.propvalue,
        description: data.description,
      });

    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Sample_Addon_Data.xlsx";
      link.click();
    });
  };



  async function fetchDData() {

    const response = await getDiscount(
      localStorage.getItem("loggedUserInfo") && JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
    );
    if (!response) {
      return;
    }
    if (response === "false") {
      setApiError(true)
    } else {
      const discount = await response.json();
      // console.log(discount);
      setDiscount(discount);
    }
  }
  useEffect(() => {
   
    if (plansInfo != null && plansInfo?.feature) {
      if (plansInfo?.feature?.memebershipplans) {
        setBasicActive("tab1");
        return;
      } else if (plansInfo?.feature?.addons) {
        setBasicActive("tab3");
        return;
      } else if (plansInfo?.feature?.timeslots) {
        setBasicActive("tab2");
        return;
      } else if (plansInfo?.feature?.discountplans) {
        setBasicActive("tab4");
        return;
      } else {
        setBasicActive("");
        return;
      }
    }
  }, []);

  async function deleteThisPlan(e, obj) {
    handleupdatePlans();
    await trackButtonClick("PlansAndAddons", "Delete_Plan", "staff", {});
    e.preventDefault();
    let ip = localStorage.getItem("ipaddress");
    let browserinfo = browserName + "-" + browserVersion + ".0.0";
    let flag = `Plan Deleted Successfull (${obj.name})`;
    let Eventtype = "plan";
    if (window.confirm("Are you sure want to delete this Plan?")) {
      await deletePlan(obj._id);
      localStorage.setItem("setting_save_plan", "Plan deleted successfully");
      let gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
      let username1 = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : "";
      logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "");
      // window.location.reload(false);

      refreshPlansData()
      dUIPlan(obj);
    }
  }

  async function deleteThisAddon(e, obj) {
    handleupdatePlans();
    await trackButtonClick("PlansAndAddons", "Delete_Addon", "staff", {});
    e.preventDefault();
    if (window.confirm("Are you sure want to delete this Addon?")) {
      await deleteAddon(obj._id);
      localStorage.setItem("setting_save_addon", "Addon deleted successfully");
      let ip = localStorage.getItem("ipaddress");
      let browserinfo = browserName + "-" + browserVersion + ".0.0";
      let flag = `Addon Deleted Successfull (${obj.name})`;
      let Eventtype = "addon";
      let gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
      let username1 = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : "";
      logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "");
      //window.location.reload(false));
      refreshAddonsData();
      dUIAddon(obj);
    }
  }
  async function deleteThisSlot(e, obj) {
    await trackButtonClick("PlansAndAddons", "Delete_Slot", "staff", {});
    e.preventDefault();
    if (window.confirm("Are you sure want to delete this Slot?")) {
      await deleteSlot(obj._id);
      localStorage.setItem("setting_save_slot", "Slot deleted successfully");
      let ip = localStorage.getItem("ipaddress");
      let browserinfo = browserName + "-" + browserVersion + ".0.0";
      let flag = `Slot Deleted Successfull (${obj.name})`;
      let Eventtype = "slot";
      let gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
      let username1 = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : "";
      logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "");
      await refreshSlotsData();
      dUISlot(obj);
    }
  }
  async function deleteThisDiscount(e, obj) {
    await trackButtonClick("PlansAndAddons", "Delete_Discount", "staff", {});
    e.preventDefault();
    if (window.confirm("Are you sure want to delete this Discount?")) {
      await deleteDiscount(obj._id);
      localStorage.setItem("setting_save_discount", "discount deleted successfully");
      let ip = localStorage.getItem("ipaddress");
      let browserinfo = browserName + "-" + browserVersion + ".0.0";
      let flag = `Discount Deleted Successfull (${obj.name})`;
      let Eventtype = "discount";
      let gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : '';
      let username1 = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : "";
      logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "");
      dUIDiscount(obj);
    }
  }

  function openEditForm(e, obj) {
    console.log("44444444444openeditform", obj);
    // e.preventDefault();

    if (obj.id == "-1") {
      if (plansInfo != null && (plansInfo.planLimitation?.memebershipplans != -1 && (plansInfo.planLimitation?.memebershipplans <= plans.length))) {
        setAlerttxt("Your Memebership Plans Limit Exceeded. Please upgarde your subscription plan!");
        return;
      }
    }

    console.log("44444444444444obj.parentId", obj.parentId);
    setEditId(obj.id);

    // If parentId exists, it's a variation plan that needs to be edited
    if (obj.parentId) {
      // Store both the parent ID (base plan) and the current ID (variation plan)
      setBaseplanId(obj.parentId);
      const parentPlanData = plans.find(plan => plan._id === obj.parentId);
      console.log("444444444444444Found parent plan data:", parentPlanData);
      setParentDate(parentPlanData)
      // Open variation plan directly
      setShowVariationPlan(true);
      // Set variation data if needed
      setVariationData(obj); // Assuming obj contains the variation data
    }

    setPlanupdate(true);
  }

  const resetVariationStates = () => {
    setShowVariationPlan(false);
    setVariationData(null);
    setBaseplanId("");
    setParentDate(null);
    setData("");
  };


  function openSlotForm(e, obj) {
    //e.preventDefault();
    // if (obj.id == "-1") {
    //   if (plansInfo != null && (plansInfo.planLimitation.timeslots != -1 && (plansInfo.planLimitation.timeslots <= slots.length))) {
    //     setAlerttxt("Your Time Slot Limit Exceeded.")
    //     return;
    //   }
    // }
    setEditId(obj.id);
    setSlotupdate(true);
  }
  function openAddonForm(e, obj) {
    //e.preventDefault();
    // if (obj.id == "-1") {
    //   if (plansInfo != null && (plansInfo.planLimitation.addons != -1 && (plansInfo.planLimitation.addons <= addons.length))) {
    //     setAlerttxt("Your Memebership Addons Limit Exceeded.");
    //     return;
    //   }
    // }
    setEditId(obj.id);
    setAddonupdate(true);
  }

  function openDiscountForm(e, obj) {
    //e.preventDefault();
    setEditId(obj);
    setcreateDiscount(true);
  }

  function closeUpdate() {
    handleupdatePlans();
    setEditId(null);
    setPlanupdate(false);
    setAddonupdate(false);
    setSlotupdate(false);
    setcreateDiscount(false);
    resetVariationStates();
  }

  const handleupdatePlans = () => {
    setReupdate(!reupdate);
  }
  const getPricingPlansBYGymid = async () => {
    const response = await getPricingPlansById(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
    if (!response || response === "false") {
      return
    }
    const recinfo = await response.json();
    if (recinfo && recinfo.feature) {
      setPlanInfo(recinfo);
      localStorage.setItem("planInfo", JSON.stringify(recinfo));
    } else {
      localStorage.removeItem("planInfo");
    }
  }
  useEffect(() => {
    if (localStorage.getItem("loggedUserInfo")) {
      getPricingPlansBYGymid();
    }
  }, [smessage, plans, addons]);
  function dUIPlan(item) {
    setSMessage(localStorage.getItem("setting_save_plan"));
    setTimeout(() => {
      setSMessage(null);
      localStorage.removeItem("setting_save_plan");
    }, 5000);
    console.log(item);
    if (plans.filter((obj) => obj._id === item._id).length > 0) {
      let remaining = plans.filter((obj) => obj._id !== item._id);
      setPlans([...remaining]);
    }

    closeUpdate();
  }
  function dUIAddon(item) {
    setSMessage(localStorage.getItem("setting_save_addon"));
    setTimeout(() => {
      setSMessage(null);
      localStorage.removeItem("setting_save_addon");
    }, 5000);
    console.log(item);
    if (addons.filter((obj) => obj._id === item._id).length > 0) {
      let remaining = addons.filter((obj) => obj._id !== item._id);
      setAddons([...remaining]);
    }

    closeUpdate();
  }
  function dUISlot(item) {
    setSMessage(localStorage.getItem("setting_save_slot"));
    setTimeout(() => {
      setSMessage(null);
      localStorage.removeItem("setting_save_slot");
    }, 5000);
    console.log(item);
    if (slots.filter((obj) => obj._id === item._id).length > 0) {
      let remaining = slots.filter((obj) => obj._id !== item._id);
      setSlots([...remaining]);
    }
    closeUpdate();
  }
  function dUIDiscount(item) {
    setSMessage(localStorage.getItem("setting_save_discount"));
    setTimeout(() => {
      setSMessage(null);
      localStorage.removeItem("setting_save_discount");
    }, 5000);
    console.log(item);
    if (discount.filter((obj) => obj._id === item._id).length > 0) {
      let remaining = discount.filter((obj) => obj._id !== item._id);
      setDiscount([...remaining]);
    }
    closeUpdate();
  }
  function updateSlot(item) {
    setSMessage(localStorage.getItem("setting_save_slot"));
    setTimeout(() => {
      setSMessage(null);
      localStorage.removeItem("setting_save_slot");
    }, 5000);
    console.log(item);

    let allslots = [];
    if (slots.filter((obj) => obj._id === item._id).length > 0) {
      let remaining = slots.filter((obj) => obj._id !== item._id);
      allslots = [...remaining, item]
    } else {
      allslots = [...slots, item]
    }

    try {
      let sortedlist = allslots.sort((a, b) => a.name.localeCompare(b.name));
      setSlots(sortedlist);
    } catch (e) {
      console.log("Error ::::::::::::::: " + e);
    }

    closeUpdate();
  }
  function updateAddon(item) {
    handleupdatePlans();
    setSMessage(localStorage.getItem("setting_save_addon"));
    setTimeout(() => {
      setSMessage(null);
      localStorage.removeItem("setting_save_addon");
    }, 5000);

    console.log(item);
    let alladdons = [];
    if (addons.filter((obj) => obj._id === item._id).length > 0) {
      let remaining = addons.filter((obj) => obj._id !== item._id);
      alladdons = [...remaining, item];
    } else {
      alladdons = [...addons, item];
    }
    try {
      let sortedlist = alladdons.sort((a, b) => a.name.localeCompare(b.name));
      setAddons(sortedlist);
    } catch (e) {
      console.log("Error ::::::::::::::: " + e);
    }

    closeUpdate();
  }
  function updateDiscount(item) {
    console.log(item);
    setSMessage("Discount Updated successfully");
    setTimeout(() => {
      setSMessage(null);
      localStorage.removeItem("setting_save_plan");
    }, 5000);

    let allDiscount = [];
    if (discount.filter((obj) => obj._id === item._id).length > 0) {
      let remaining = discount.filter((obj) => obj._id !== item._id);
      console.log("remaining...");
      console.log(remaining);
      allDiscount = [...remaining, item];
    } else {
      allDiscount = [...discount, item];
    }

    try {
      let sortedplans = allDiscount.sort((a, b) => a.name.localeCompare(b.name));
      setDiscount(sortedplans);
    } catch (e) {
      console.log("Error ::::::::::::::: " + e);
    }

    closeUpdate();
  }


  const refreshAllData = async () => {
    try {
      await fetchPData();
      await fetchSData();
      await fetchAddons();
      await fetchDData();
    } catch (error) {
      console.error("Error refreshing data:", error);
    }
  };

  const refreshPlansData = async () => {
    try {
      await fetchPData();
    } catch (error) {
      console.error("Error refreshing plans data:", error);
    }
  };

  const refreshAddonsData = async () => {
    try {
      await fetchAddons();
    } catch (error) {
      console.error("Error refreshing addons data:", error);
    }
  };

  const refreshSlotsData = async () => {
    try {
      await fetchSData();
    } catch (error) {
      console.error("Error refreshing slots data:", error);
    }
  };



  function updatePlan(item) {
    handleupdatePlans();
    console.log(item);
    setSMessage(localStorage.getItem("setting_save_plan"));
    setTimeout(() => {
      setSMessage(null);
      localStorage.removeItem("setting_save_plan");
    }, 5000);

    setTimeout(() => {
      refreshPlansData();
    }, 100);


    let allPlans = [];
    if (plans.filter((obj) => obj._id === item._id).length > 0) {
      let remaining = plans.filter((obj) => obj._id !== item._id);
      console.log("remaining...");
      console.log(remaining);
      allPlans = [...remaining, item];
    } else {
      allPlans = [...plans, item];
    }

    try {
      let sortedplans = allPlans.sort((a, b) => a.name.localeCompare(b.name));
      setPlans(sortedplans);
    } catch (e) {
      console.log("Error ::::::::::::::: " + e);
    }

    closeUpdate();
  }

  function getSlotName(slotid) {
    let tobj = slots.filter((item) => item._id === slotid)[0];
    return tobj ? tobj.name : "";
  }
  async function fetchAddons() {

    const response = await getGymAddonsList(
      localStorage.getItem("loggedUserInfo") && JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
    );
    if (!response) {
      return;
    }
    if (response === "false") {
      setApiError(true)
    } else {
      setAddons(await response.json());
      console.log("plansInfo set..");
    }
  }
  console.log(addons);


  useEffect(() => {
    if (!planupdate) {
      resetVariationStates();
    }
  }, [planupdate]);



  async function fetchPData() {

    const response = await getPlans(
      JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
    );
    console.log(response);

    if (!response) {
      return;
    }
    if (response === "false") {
      setApiError(true)
    } else {
      let plans = await response.json();
      console.log("plans", plans);
      if (!plans) {
        // window.alert(`info with id  not found`);
        navigate("/");
        return;
      }
      // if ((plansInfo !== null && plansInfo?.feature?.planswithsessionslimit)) {
      //   plans = plans
      // } else {
      //   plans = plans.filter((obj) => obj.sessioncheck == false)
      // }


      const activePlans = plans.filter((plan) => plan.archived !== true);

      setPlans(activePlans);
    }
  }

  async function fetchSData() {
    const response = await getSlots(
      localStorage.getItem("loggedUserInfo") && JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
    );
    if (!response) {
      return;
    }
    if (response === "false") {
      setApiError(true)
    } else {
      const slots = await response.json();
      console.log(slots);
      if (!slots) {
        window.alert(`info with id  not found`);
        navigate("/");
        return;
      }
      if (localStorage.getItem("setting_save_addon")) {
        setSMessage(localStorage.getItem("setting_save_addon"));
        setTimeout(() => {
          setSMessage(null);
          localStorage.removeItem("setting_save_addon");
        }, 5000);
      }
      if (localStorage.getItem("setting_save_plan")) {
        setSMessage(localStorage.getItem("setting_save_plan"));
        setTimeout(() => {
          setSMessage(null);
          localStorage.removeItem("setting_save_plan");
        }, 5000);
      }
      if (localStorage.getItem("setting_save_slot")) {
        setSMessage(localStorage.getItem("setting_save_slot"));
        setTimeout(() => {
          setSMessage(null);
          localStorage.removeItem("setting_save_slot");
        }, 5000);
      }
      setSlots(slots);
    }
  }


  useEffect(() => {

    if (localStorage.getItem("loggedUserInfo")) {
      fetchPData();
      fetchSData();
      fetchAddons();
      fetchDData();
    } else {
      navigate("/login")
    }
  }, [navigate, importAddonPopUp, importPopUp, importPlanPopUp]);

  const [basicActive, setBasicActive] = useState('tab1');

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };

  console.log(plans);
  const filteredPlans = (plans && plans.length > 0 ? plans : []).filter((plan) => {
    // If the plan has subplans, we need to check if ANY subplan matches the filter
    if (plan.subplans && plan.subplans.length > 0) {
      const hasMatchingSubplan = plan.subplans.some((subplan) => {
        // Filter by Enable/Disable for subplan
        if (mfilter.ptoggle) {
          const isEnabledFilter = mfilter.ptoggle === "enable";
          const subplanEnabled = subplan.enable === true;

          if (isEnabledFilter && !subplanEnabled) {
            return false; // Filter is "enable" but subplan is disabled
          }
          if (!isEnabledFilter && subplanEnabled) {
            return false; // Filter is "disable" but subplan is enabled
          }
        }
        if (plansInfo != null && plansInfo?.feature?.planswithsessionslimit === false) {
          if (subplan.sessionvalue == true) {
            return false;
          }
        }

        // Filter by Plan Type - FIXED THIS SECTION
        if (mfilter.pType) {
          const isOneTimeFilter = mfilter.pType === "onetime";
          const subplanOneTime = subplan.ptype === 1;

          if (isOneTimeFilter && !subplanOneTime) {
            return false; // Filter is "onetime" but subplan is recurring
          }
          if (!isOneTimeFilter && subplanOneTime) {
            return false; // Filter is "recuring" but subplan is one-time
          }
        }
        return true;
      });

      // Keep this parent plan if it has at least one matching subplan


      console.log("hasMatchingSubplan", hasMatchingSubplan);

      return hasMatchingSubplan;
    } else {
      // This is a regular plan without subplans
      // Filter by Enable/Disable for main plan
      if (mfilter.ptoggle) {
        const isEnabledFilter = mfilter.ptoggle === "enable";
        const planEnabled = plan.enable === true;

        if (isEnabledFilter && !planEnabled) {
          return false;
        }
        if (!isEnabledFilter && planEnabled) {
          return false;
        }
      }

      if (plansInfo != null && plansInfo?.feature?.planswithsessionslimit === false) {
        if (plan.sessionvalue == true) {
          return false;
        }
      }

      // Filter by Plan Type - FIXED THIS SECTION
      if (mfilter.pType) {
        const isOneTimeFilter = mfilter.pType === "onetime";
        const planOneTime = plan.ptype === 1;

        if (isOneTimeFilter && !planOneTime) {
          return false; // Filter is "onetime" but plan is recurring
        }
        if (!isOneTimeFilter && planOneTime) {
          return false; // Filter is "recuring" but plan is one-time
        }
      }

      return true;
    }
  });


  console.log(filteredPlans, "filteredPlans");

  /**
 * creating array of plans data .
  * created by vamshi
 * @array
 * 
 * @description
 * This planarry has been created on [4-11-2023] to include additional plans data in to table.
 */


  let snoCounter = 1;


  const planarry = filteredPlans?.flatMap((item) => {
    // If the plan has subplans, skip the main plan row
    if (item.subplans && item.subplans.length > 0) {
      const sortedSubplans = [...item.subplans].sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      );


      return sortedSubplans.map((subplan) => {
        // const basePlan = plans.find((p) => p._id === subplan.baseplan);
        const baseName = BasePlanName(plans, subplan.baseplan);
        const displayName = `${baseName || ''}-${subplan.name || ''}`;


        return [
          snoCounter++,
          displayName,
          `${subplan.numberofdays} ${subplan.validityflag === 1
            ? "Days"
            : subplan.validityflag === 2
              ? "Months"
              : "Years"
          }`,
          subplan.sessioncheck && subplan.sessionvalue !== "" ? subplan.sessionvalue : "--",
          subplan.discount === "1"
            ? "5"
            : subplan.discount === "2"
              ? "10"
              : subplan.discount === "3"
                ? "15"
                : subplan.discount === "4"
                  ? "50"
                  : subplan.discount === "5"
                    ? "100"
                    : "No Discounts",
          (subplan.pdays || []).length > 6
            ? "All days"
            : (subplan.pdays || [])
              .map((ite) =>
                ite.day === 1
                  ? "Sun, "
                  : ite.day === 2
                    ? "Mon, "
                    : ite.day === 3
                      ? "Tue, "
                      : ite.day === 4
                        ? "Wed, "
                        : ite.day === 5
                          ? "Thu, "
                          : ite.day === 6
                            ? "Fri, "
                            : "Sat"
              )
              .join(""),
          (subplan.pslots || [])
            .map((slot) => getSlotName(slot._id))
            .filter(Boolean)
            .join(", "),
          subplan.ptype === 1 ? "One-time" : "Recurring",
          subplan.price ? `₹${subplan.price}` : "",
          subplan.taxcheck ? "Included" : "Excluded",
          subplan.enable ? "Enabled" : "Disabled",
          subplan.forcetrainer ? "Enabled" : "Disabled",
          subplan.autocheckin ? "Enabled" : "Disabled",
          roleAccess?.editmembership !== 2 && <MDBIcon
            fas
            icon="edit"
            className="fs-6 ps-2"
            onClick={
              roleAccess?.editmembership !== 2
                ? (e) =>
                  openEditForm(e, {
                    id: subplan._id,
                    parentId: item._id,
                    isSubplan: true,
                  })
                : undefined
            }
          />,
          roleAccess?.editmembership !== 2 && <MDBIcon
            fas
            icon="trash"
            className="fs-6 ps-2"
            onClick={
              roleAccess?.editmembership !== 2 ? (e) => deleteThisPlan(e, subplan, item._id) : undefined
            }
          />,
        ];
      });
    }

    // Show the main plan only if it has NO subplans
    const mainPlanRow = [
      snoCounter++,
      item.name,
      `${item.numberofdays} ${item.validityflag === 1
        ? "Days"
        : item.validityflag === 2
          ? "Months"
          : "Years"
      }`,
      item.sessioncheck && item.sessionvalue !== "" ? item.sessionvalue : "--",
      item.discount === "1"
        ? "5"
        : item.discount === "2"
          ? "10"
          : item.discount === "3"
            ? "15"
            : item.discount === "4"
              ? "50"
              : item.discount === "5"
                ? "100"
                : "No Discounts",
      (item.pdays || []).length > 6
        ? "All days"
        : (item.pdays || [])
          .map((ite) =>
            ite.day === 1
              ? "Sun, "
              : ite.day === 2
                ? "Mon, "
                : ite.day === 3
                  ? "Tue, "
                  : ite.day === 4
                    ? "Wed, "
                    : ite.day === 5
                      ? "Thu, "
                      : ite.day === 6
                        ? "Fri, "
                        : "Sat"
          )
          .join(""),
      (item.pslots || [])
        .map((slot) => (getSlotName(slot._id) !== "" ? getSlotName(slot._id) : null))
        .filter(Boolean)
        .join(", "),
      item.ptype === 1 ? "One-time" : "Recurring",
      item.price ? "₹" + item.price : "",
      item.taxcheck ? "Included" : "Excluded",
      item.enable ? "Enabled" : "Disabled",
      item.forcetrainer ? "Enabled" : "Disabled",
      item.autocheckin ? "Enabled" : "Disabled",
      roleAccess?.editmembership !== 2 ? (
        <MDBIcon
          fas
          icon="edit"
          className="fs-6 ps-2"
          onClick={(e) => openEditForm(e, { id: item._id })}
        />
      ) : null,
      roleAccess?.editmembership !== 2 ? (
        <MDBIcon
          fas
          icon="trash"
          className="fs-6 ps-2"
          onClick={(e) => deleteThisPlan(e, item)}
        />
      ) : null,
    ].filter(item => item !== null);


    return [mainPlanRow];
  });

  /**
  * creating array of slots data .
  * created by vamshi
  * @array
  * 
  * @description
  * This slotarry has been created on [4-11-2023] to include additional slots data in to table.
  */
  const slotArry = slots.length > 0 ? slots.map((item, index) => {
    const array = [];
    array.push(index + 1);
    array.push(item.name);
    array.push(`${item.shrs}:${item.smins === "1" ? "00" : item.smins === "2" ? "15" : item.smins === "3" ? "30" : "45"} ${item.shflag === "1" ? "AM" : "PM"} To ${item.ehrs}:${item.emins === "1" ? "00" : item.emins === "2" ? "15" : item.emins === "3" ? "30" : "45"} ${item.ehflag === "1" ? "AM" : "PM"}`);

    const editIcon = (
      <MDBIcon
        fas
        icon="edit"
        className="fs-6 ps-2"
        onClick={(e) => roleAccess?.editmembership !== 2 ? openSlotForm(e, { id: item._id }) : undefined}
      />
    );


    const deleteIcon = (
      <MDBIcon
        fas
        icon="trash"
        className="fs-6 ps-2"
        onClick={(e) => roleAccess?.editmembership !== 2 ? deleteThisSlot(e, item) : undefined}
      />
    );
    if (roleAccess?.editmembership !== 2) {
      array.push(editIcon);
      array.push(deleteIcon);
    }

    return array;
  }) : [];

  console.log(mfilter);

  const filteredAddons = (addons && addons.length > 0 ? addons : [])
    .filter((addon) => {
      if (mfilter.atoggle) {
        const isEnabled = mfilter.atoggle === "enable";
        if ((addon.enable && !isEnabled) || (!addon.enable && isEnabled)) {
          return false;
        }
      }

      return true;
    });

  /**
  * creating array of addon data .
  * created by vamshi
  * @array
  * @description
  * This addary has been created on [4-11-2023] to include additional addon data in to table.
  */

  const addary = filteredAddons && filteredAddons.map((item, index) => {
    const array = [];
    array.push(index + 1);
    array.push(item.name);
    array.push(
      item.rentbasis === "0" ? "Hourly" :
        item.rentbasis === "1" ? "Daily" :
          item.rentbasis === "2" ? "Monthly" :
            "Yearly"
    );
    array.push(item.price ? "₹" + item.price : "₹" + item.props[0].propvalue);

    array.push(item.taxcheck ? "Included" : "Excluded");
    array.push(item.enable ? "Enabled" : "Disabled"); // Vamshi

    const editIcon = (
      <MDBIcon
        fas
        icon="edit"
        className="fs-6 ps-2"
        onClick={roleAccess?.editmembership !== 2 ? (e) => openAddonForm(e, { id: item._id }) : undefined}
      />
    );


    const deleteIcon = (
      <MDBIcon
        fas
        icon="trash"
        className="fs-6 ps-2"
        onClick={roleAccess?.editmembership !== 2 ? (e) => deleteThisAddon(e, item) : undefined}
      />
    );
    if (roleAccess?.editmembership !== 2) {
      array.push(editIcon);
      array.push(deleteIcon);
    }


    return array;
  });

  const disarry = discount.length > 0 ? discount.map((item, index) => {
    const array = [];
    array.push(index + 1);
    array.push(item.title);
    array.push(item.apply);
    array.push(item.discount);
    array.push(item.mingroup);
    array.push(item.packagetype);
    array.push(item.couponcode);
    array.push(item.ontimerenewal ? "Yes" : "No");
    array.push(item.primarydiscount ? "Yes" : "No");

    const editIcon = (
      <MDBIcon
        fas
        icon="edit"
        className="fs-6 ps-2"
        onClick={(e) => openDiscountForm(e, item)}
      />
    );
    array.push(editIcon);

    const deleteIcon = (
      <MDBIcon
        fas
        icon="trash"
        className="fs-6 ps-2"
        onClick={(e) => deleteThisDiscount(e, item)}
      />
    );
    array.push(deleteIcon);

    return array;
  }) : [];
  const getPlanColumns = () => {
    const baseColumns = [
      { label: "S.no", field: "sNo", sort: false },
      { label: "Plan Name", field: "name", sort: false },
      { label: "Validity", field: "validity", sort: false },
      { label: "Session(s)", field: "session", sort: false },
      { label: "Discount(%)", field: "discount", sort: false },
      { label: "Valid Days", field: "validDays", sort: false },
      { label: "Allowed Slot", field: "allowedSlot", sort: false },
      { label: "Plan Type", field: "membershipType", sort: false },
      { label: "Price", field: "price", sort: false },
      { label: "Tax", field: "tax", sort: false },
      { label: "Enable/Disable", field: "Enable/Disable", sort: false },
      { label: "Force Trainer", field: "forceTrainer", sort: false },
      { label: "AutoCheck-In", field: "autoCheck-In", sort: false }
    ];

    if (roleAccess?.editmembership !== 2) {
      baseColumns.push(
        { label: "Edit", field: "edit", sort: false },
        { label: "Delete", field: "delete", sort: false }
      );
    }

    return baseColumns;
  };
  const basicData = {
    columns: getPlanColumns(),
    rows: planarry
  };
  const getSlotColumns = () => {
    const baseColumns = [
      { label: "S.no", field: "sNo", sort: false },
      { label: "Slot Name", field: "slotName", sort: false },
      { label: "Slot Time", field: "slotTime", sort: false },
    ];

    if (roleAccess?.editmembership !== 2) {
      baseColumns.push(
        { label: "Edit", field: "edit", sort: false },
        { label: "Delete", field: "delete", sort: false }
      );
    }

    return baseColumns;
  };

  const basicData2 = {
    columns: getSlotColumns(),
    rows: slotArry
  };

  const getAddonColumns = () => {
    const baseColumns = [
      { label: "S.no", field: "sNo", sort: false },
      { label: "Addon Name", field: "addonName", sort: false },
      { label: "Validity", field: "validity", sort: false },
      { label: "Price", field: "price", sort: false },
      { label: "Tax", field: "tax", sort: false },
      { label: "Enable/Disable", field: "checkbox", sort: false },
    ];

    if (roleAccess?.editmembership !== 2) {
      baseColumns.push(
        { label: "Edit", field: "edit", sort: false },
        { label: "Delete", field: "delete", sort: false }
      );
    }

    return baseColumns;
  };
  const basicData3 = {
    columns: getAddonColumns(),
    rows: addary
  };
  console.log(basicData, basicData2, basicData3, 'basicData');

  const basicData4 = {
    columns: [
      { label: "S.no", field: "sNo", sort: false },
      { label: "Title", field: "Title", sort: false },
      { label: "Apply", field: "Apply", sort: false },
      { label: "Discount", field: "Discount", sort: false },
      { label: "Min Group", field: "MinGroup", sort: false },
      { label: "Package Type", field: "PackageType", sort: false },
      { label: "Coupon Code", field: "CouponCode", sort: false },
      { label: "On Time Renewal", field: "Renewal", sort: false },
      { label: "Primary discount", field: "primarydiscount", sort: false },
      { label: "Edit", field: "edit", sort: false },
      { label: "Delete", field: "delete", sort: false },
    ],
    rows: disarry
  };
  const handleReload = () => {
    window.location.reload();
  }
  const checkSlotOverlap = (newSlot, existingSlots) => {
    const newSlotStart = new Date(newSlot.shrs, newSlot.smins);
    const newSlotEnd = new Date(newSlot.ehrs, newSlot.emins);

    for (const existingSlot of existingSlots) {
      const existingSlotStart = new Date(existingSlot.shrs, existingSlot.smins);
      const existingSlotEnd = new Date(existingSlot.ehrs, existingSlot.emins);

      const isNameMatch = existingSlot.name.toLowerCase() === newSlot.name.toLowerCase();


      const isSameStartTime = newSlotStart.getTime() === existingSlotStart.getTime();
      const isSameEndTime = newSlotEnd.getTime() === existingSlotEnd.getTime();

      if (!(newSlot._id === existingSlot._id)) {
        if (isNameMatch && isSameStartTime && isSameEndTime) {
          return 'Slot name and time overlap with existing slots.';
        } else if (isNameMatch) {
          return 'Slot name matches with existing slots.';
        } else if (isSameStartTime && isSameEndTime) {
          return 'Slot time overlaps with existing slots.';
        }
      }
    }

    return '';
  };

  const getTimeInMinutes = (hrs, mins, flag) => {
    let hours = parseInt(hrs);
    let minutes = parseInt(mins);
    if (flag === '2') { // PM
      if (hours < 12) hours += 12;
    } else if (flag === '1') { // AM
      if (hours === 12) hours = 0;
    }
    return hours * 60 + minutes;
  };

  const importSlotExcelSheet = async (file) => {

    if (!file) {
      console.error("No file selected");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const reader = new FileReader();

    reader.onload = async () => {
      const buffer = reader.result;
      await workbook.xlsx.load(buffer);
      const worksheet = workbook.getWorksheet(1);
      const importedData = [];
      const validationErrors = [];

      const headers = {};
      worksheet.getRow(1).eachCell((cell, colNumber) => {
        headers[cell.value] = colNumber;
      });

      const requiredHeaders = [
        "Slot Name", "Start Hours", "Start Minutes", "Start Hour Flag",
        "End Hours", "End Minutes", "End Hour Flag"
      ];

      for (const header of requiredHeaders) {
        if (!headers[header]) {
          console.error(`Missing required column: ${header}`);
          alert(`Excel is missing column: ${header}`);
          return;
        }
      }
      const response = await getSlots(
        localStorage.getItem("loggedUserInfo") && JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
      );
      if (!response) {
        return;
      }
      if (response === "false") {
        setApiError(true)
      }
      const existingSlots = await response.json();
      const mapMinutes = (minutes) => {
        switch (minutes) {
          case '00': return '1';
          case '15': return '2';
          case '30': return '3';
          case '45': return '4';
          default: return '0';
        }
      };

      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1) {
          const slotName = row.getCell(headers['Slot Name']).value?.toString() || "";
          const shrs = row.getCell(headers['Start Hours']).value?.toString() || "";
          const shflag = row.getCell(headers['Start Hour Flag']).value?.toString() || "";
          const smins = row.getCell(headers['Start Minutes']).value?.toString() || "";
          const ehrs = row.getCell(headers['End Hours']).value?.toString() || "";
          const ehflag = row.getCell(headers['End Hour Flag']).value?.toString() || "";
          const emins = row.getCell(headers['End Minutes']).value?.toString() || "";

          const errors = [];


          if (!slotName) errors.push("Slot Name is Required");
          if (!shrs || isNaN(shrs)) errors.push("Start Hours must be a number");
          if (!["AM", "PM"].includes(shflag)) errors.push("Start Hour Flag must be AM or PM");
          if (!smins || !["00", "15", "30", "45"].includes(smins)) errors.push("Invalid Start Minutes");
          if (!ehrs || isNaN(ehrs)) errors.push("End Hours must be a number");
          if (!["AM", "PM"].includes(ehflag)) errors.push("End Hour Flag must be AM or PM");
          if (!emins || !["00", "15", "30", "45"].includes(emins)) errors.push("Invalid End Minutes");




          if (errors.length > 0) {
            validationErrors.push({ row: rowNumber, errors });
          } else {

            const transformedRow = {
              name: slotName,
              shrs: shrs,
              shflag: shflag === 'AM' ? '1' : '2',
              smins: mapMinutes(smins),
              ehrs: ehrs,
              ehflag: ehflag === 'AM' ? '1' : '2',
              emins: mapMinutes(emins),
            };

            const overlapError = checkSlotOverlap(transformedRow, existingSlots);
            if (overlapError) {
              validationErrors.push({ row: rowNumber, errors: [overlapError] });
            }
            else {
              const newStart = getTimeInMinutes(transformedRow.shrs, transformedRow.smins, transformedRow.shflag);
              const newEnd = getTimeInMinutes(transformedRow.ehrs, transformedRow.emins, transformedRow.ehflag);

              const internalOverlap = importedData.find(existingSlot => {
                const existingStart = getTimeInMinutes(existingSlot.shrs, existingSlot.smins, existingSlot.shflag);
                const existingEnd = getTimeInMinutes(existingSlot.ehrs, existingSlot.emins, existingSlot.ehflag);

                const isOverlapping = (newStart < existingEnd) && (newEnd > existingStart);
                return isOverlapping;

              });
              if (internalOverlap) {
                validationErrors.push({ row: rowNumber, errors: ['Duplicate slot found in Excel file.'] });
              } else {
                importedData.push(transformedRow);
              }
            }
          }
        }
      });



      let requestData = {
        gymId: localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "",
      };


      if (validationErrors.length > 0) {
        console.error("Validation Errors:", validationErrors);

        requestData.status = "failed";
        requestData.errors = validationErrors;
        setSlotErrorMessage(validationErrors.map(e => `Row ${e.row}: ${e.errors.join(", ")}`).join("\n"));
        setTimeout(() => {
          setImportPopUp(false);
          setSlotErrorMessage("");
        }, 20000);
        await saveImportedSlot(requestData);



        return;
      }


      setImportedSlotData(importedData);

      if (importedData.length === 0) {

        setImportSlotError("The file is empty or does not contain valid Slot data.");
        setImportPopUp(false);
        return;
      } else {
        setImportSlotError("");
      }


      try {
        console.log("Data for Backend:", importedData);

        requestData.status = "success";
        requestData.data = importedData;
        // if ((slots.length + importedData.length) > plansInfo?.limitation?.slots) {
        //   setAlerttxt("Your imported data exceeds the allowed limit. Please upgrade your plan for higher capacity.");
        //   return;
        // }
        let response = await saveImportedSlot(requestData);
        console.log("responseresponseresponseresponse", response);

        if (!response) {
          return;
        }
        if (response === "false") {
          setApiError(true)
        }
        else {
          const result = await response.json();
          console.log("Backend Response:", result);
          if (result.message == "Success") {
            setAlerttxtt("Slot(s) Imported successfully!");
            await trackButtonClick("PlansAndAddons", "Slot_Import", "staff", {});

          }
          else {
            setError2("Failed to Import Slots(s)");
          }
          setImportPopUp(false);
        }


      } catch (error) {
        console.error("Error during import:", error.message);

        requestData.status = "failed";
        requestData.errors = [{ error: error.message }];

        await saveImportedSlot(requestData);
      }
    };

    reader.readAsArrayBuffer(file);
  };


  const handleSampleSlotsDownload = () => {
    const sampleData = [
      {
        name: "Evening Slot",
        shrs: "4",
        shflag: "PM",
        smins: "00",
        ehflag: "PM",
        ehrs: "6",
        emins: "00",

      },
      {
        name: "Morning Slot",
        shrs: "7",
        shflag: "AM",
        smins: "30",
        ehflag: "AM",
        ehrs: "9",
        emins: "30",

      },
    ];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sample Data');


    worksheet.columns = [
      { header: 'Slot Name', key: 'name', width: 20 },
      { header: 'Start Hours', key: 'shrs', width: 15 },
      { header: 'Start Minutes', key: 'smins', width: 15 },
      { header: 'Start Hour Flag', key: 'shflag', width: 15 },
      { header: 'End Hours', key: 'ehrs', width: 15 },
      { header: 'End Minutes', key: 'emins', width: 15 },
      { header: 'End Hour Flag', key: 'ehflag', width: 15 },

    ];

    sampleData.forEach(data => {
      worksheet.addRow(data);
    });


    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'Sample_Slots.xlsx';
      link.click();
    });
  };




  return (
    <>
      <LeftPane isactive="7" />
      <Header />
      {apiError ? <PageError handleReload={handleReload} /> :
        <div
          className="gym-main rightContent"
        >
          {" "}
          {smessage && <Toast message={smessage} />}
          <PlansHeader
            onPlanAdd={openEditForm}
            onAddonAdd={openAddonForm}
            onSlotAdd={openSlotForm}
            onAddDiscount={openDiscountForm}
          />
          <div className="remaindersmains w-100">


            <MDBTabs className='mb-3'>
              {(plansInfo !== null && plansInfo.feature.memebershipplans) ?
                <MDBTabsItem>
                  <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                    Plans
                  </MDBTabsLink>
                </MDBTabsItem>
                : ""}
              {(plansInfo !== null && plansInfo.feature.timeslots) ?
                <MDBTabsItem>
                  <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                    Slots
                  </MDBTabsLink>
                </MDBTabsItem>
                : ""}
              {(plansInfo !== null && plansInfo.feature.addons) ?
                <MDBTabsItem>
                  <MDBTabsLink onClick={() => handleBasicClick('tab3')} active={basicActive === 'tab3'}>
                    Addons
                  </MDBTabsLink>
                </MDBTabsItem>
                : ""}
              {/* {(plansInfo === null || (plansInfo.planFeature && plansInfo.planFeature.discountplans)) ?
              <MDBTabsItem>
                <MDBTabsLink onClick={() => handleBasicClick('tab4')} active={basicActive === 'tab4'}>
                  discounts
                </MDBTabsLink>
              </MDBTabsItem>
                : ""}*/}
            </MDBTabs>
            <div className='d-flex'>


              {/* {basicActive === 'tab3' &&
                <div className="gym-section w-100-mobile ms-2">
                  <label className="fw-bold">Enable/Disable</label>
                  <div>
                    <select
                      name="emailReminder"
                      id="emailReminder"
                      className="form-control select-input form-select placeholder-active me-3 shadow-1 form-selectMobile"
                      value={mfilter.atoggle}
                      onChange={(e) => setMfilter({
                        ...mfilter,
                        atoggle: e.target.value
                      })}
                    >
                      <option value="">All</option>
                      <option value="enable">Enable</option>
                      <option value="disable">Disable</option>
                    </select>
                  </div>
                </div>} */}

            </div>



            <MDBTabsContent>
              <MDBTabsPane show={basicActive === 'tab1'} open={basicActive === 'tab1'}>
                <div className="position-relative">
                  <div className="refundsExportButton">
                    {basicActive === 'tab1' &&
                      <>
                        <div className="filterTypes w-100-mobile ms-2">
                          <label className="fw-bold">Enable/Disable</label>
                          <div style={{ marginTop: '4px' }}>
                            <select
                              name="emailReminder"
                              id="emailReminder"
                              className="form-control select-input form-select placeholder-active me-3 shadow-1 form-selectMobile"
                              value={mfilter.ptoggle}

                              onChange={(e) => setMfilter({
                                ...mfilter,
                                ptoggle: e.target.value
                              })}
                            >
                              <option value="">All</option>
                              <option value="enable">Enable</option>
                              <option value="disable">Disable</option>
                            </select>
                          </div>
                        </div>

                        <div className="filterTypes w-100-mobile ms-2">
                          <label className="fw-bold">Plan Type</label>
                          <div style={{ marginTop: '4px' }}>
                            <select
                              name="emailReminder"
                              id="emailReminder"
                              className="form-control select-input form-select placeholder-active me-3 shadow-1 form-selectMobile"
                              value={mfilter.pType}
                              onChange={(e) => setMfilter({
                                ...mfilter,
                                pType: e.target.value
                              })}
                            >
                              <option value="">All</option>
                              <option value="onetime">One-Time</option>
                              <option value="recuring">Recurring</option>
                            </select>
                          </div>
                        </div>
                        {(localStorage.getItem("loggedUserInfo")) &&
                          roleAccess?.import == 1 &&
                          plansInfo != null && plansInfo?.planUsage?.plansflag &&
                          <button type="submit" className="ms-2 btnheight btn btn-primary" onClick={tooglePlanPopup}>
                            <MDBIcon fas icon="file-import" className="d-inline me-1" />Import
                          </button>
                        }
                      </>
                    }
                  </div>
                  <div className="refundsTable search">
                    <MDBDatatable className="sno PlansDataTable"
                      fixedHeader
                      entries={50}
                      searchLabel="search here..." search
                      data={basicData} />
                  </div>
                </div>
              </MDBTabsPane>
              <MDBTabsPane show={basicActive === 'tab2'} open={basicActive === 'tab2'}>
                <div className="position-relative">
                  <div className="refundsExportButton">

                    {(localStorage.getItem("loggedUserInfo")) && roleAccess?.import == 1 &&
                      <button type="submit" className="ms-2 btnheight btn btn-primary" onClick={toggleModal}>
                        <MDBIcon fas icon="file-import" className="d-inline me-1" />Import
                      </button>
                    }
                  </div>
                  <div className="refundsTable search">
                    <MDBDatatable className="sno mt-2 large-scrool-table"
                      fixedHeader
                      entries={50}
                      searchInputProps={{ className: "discountsDataTableSearch" }}
                      searchLabel="search here..." search
                      data={basicData2} />
                  </div>
                </div>
              </MDBTabsPane>
              <MDBTabsPane show={basicActive === 'tab3'} open={basicActive === 'tab3'}>
                <div className="position-relative">
                  <div className="refundsExportButton">
                    {basicActive === 'tab3' &&
                      <div className="filterTypes w-100-mobile ms-2">
                        <label className="fw-bold">Enable/Disable</label>
                        <div >
                          <select
                            name="emailReminder"
                            id="emailReminder"
                            className="form-control select-input form-select placeholder-active me-3 shadow-1 form-selectMobile"
                            value={mfilter.atoggle}
                            onChange={(e) => setMfilter({
                              ...mfilter,
                              atoggle: e.target.value
                            })}
                          >
                            <option value="">All</option>
                            <option value="enable">Enable</option>
                            <option value="disable">Disable</option>
                          </select>
                        </div>
                      </div>}
                    {(localStorage.getItem("loggedUserInfo")) && roleAccess?.import == 1 &&
                      plansInfo != null && plansInfo?.planUsage?.addonsflag &&
                      <button type="submit" className="ms-2 btnheight btn btn-primary" onClick={toogleAddonPopup}>
                        <MDBIcon fas icon="file-import" className="d-inline me-1" />Import
                      </button>
                    }
                  </div>
                  <div className="refundsTable search">
                    <MDBDatatable className="sno addOnsDataTable large-scrool-table"
                      fixedHeader
                      searchLabel="search here..." search
                      entries={50}
                      data={basicData3} />
                  </div>
                </div>
              </MDBTabsPane>
              <MDBTabsPane show={basicActive === 'tab4'} open={basicActive === 'tab4'}>

                <MDBDatatable className="sno discountsDataTable large-scrool-table"
                  fixedHeader
                  searchLabel="search here..." search
                  entries={50}
                  data={basicData4} />

              </MDBTabsPane>
            </MDBTabsContent>
          </div>
        </div>}

      {planupdate && (
        <>
          <MDBModal open={planupdate} onClose={() => {
            setPlanupdate(false);
            resetVariationStates();
          }} tabIndex='-1'>
            <MDBModalDialog size='xl'>
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>Create/Edit Plan</MDBModalTitle>
                  <MDBBtn className='btn-close' color='none' onClick={() => setPlanupdate(false)}></MDBBtn>
                </MDBModalHeader>
                <MDBModalBody className='d-flex flex-column h-100'>
                  {showVariationPlan ? (
                    <VaritationPlan
                      onBack={handleBackToCreatePlan}
                      id={editId}
                      baseplanId={baseplanId}
                      onsubmit={updatePlan}
                      data={variationData}
                      onclose={() => {
                        closeUpdate();
                        resetVariationStates();
                      }}
                      parentData={parentData}
                    />
                  ) : (
                    <CreatePlan
                      id={editId}
                      onsubmit={updatePlan}
                      onclose={() => {
                        closeUpdate();
                        resetVariationStates();
                      }}
                      onShowVariation={() => {
                        setBaseplanId(editId);
                        setShowVariationPlan(true);
                      }}
                      setVariationData={setVariationData}
                      variationData={variationData}
                      data={data}
                    />
                  )}
                </MDBModalBody>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>
        </>
      )}










      {slotupdate && (
        <Popup
          title="Create/Edit Slot"
          ptype="modal-lg"
          content={
            <>
              <div>
                <CreateSlot
                  id={editId}
                  ispopup="0"
                  onsubmit={updateSlot}
                  onclose={closeUpdate}
                  oncancel={closeUpdate}
                />
              </div>
            </>
          }
          handleClose={closeUpdate}
        />
      )}

      {addonupdate && (
        <Popup
          title="Create/Edit Addon"
          ptype="modal-lg"
          content={
            <>
              <div>
                <CreateAddon
                  id={editId}
                  onsubmit={updateAddon}
                  onclose={closeUpdate}
                />
              </div>
            </>
          }
          handleClose={closeUpdate}
        />
      )}

      {createDiscount && (
        <Popup
          title="Create/Edit Discount"
          ptype="modal-lg"
          content={
            <>
              <div>
                <CreateDiscount
                  id={editId._id}
                  data={editId}
                  onsubmit={updateDiscount}
                  onclose={closeUpdate}
                />
              </div>
            </>
          }
          handleClose={closeUpdate}
        />
      )}
      <MDBAlert
        color="danger"
        autohide
        position='top-right'
        delay={4000}
        appendToBody
        open={Alerttxt != ""}
        onClose={() => setAlerttxt("")}
      >
        {Alerttxt}
      </MDBAlert>

      <MDBAlert
        color="success"
        autohide
        position='top-center'
        delay={4000}
        appendToBody
        open={Alerttxtt != ""}
        onClose={() => setAlerttxtt("")}
      >
        {Alerttxtt}
      </MDBAlert>
      <ImportExcelModal
        isOpen={importPlanPopUp}
        toggleModalClose={tooglePlanClose}
        onDownloadSample={handleSamplePlanDownload}
        onImportFile={importPlanExcelSheet}
        errorMessage={planErrorMessage}
      />
      <MDBAlert
        color='danger'
        autohide
        position='top-right'
        delay={5000}
        appendToBody
        open={Error2 != ""}
        onClose={() => setError2("")}
      >
        {Error2}
      </MDBAlert>

      <ImportExcelModal
        isOpen={importAddonPopUp}
        toggleModalClose={toogleAddonClose}
        onDownloadSample={handleSampAddonDownload}
        onImportFile={importAddonExcelSheet}
        errorMessage={AddonerrorMessage}
      />


      <ImportExcelModal
        isOpen={importPopUp}
        toggleModalClose={popUpClose}
        onDownloadSample={handleSampleSlotsDownload}
        onImportFile={importSlotExcelSheet}
        errorMessage={slotErrorMessage}

      />

      {importPlanError && (
        <MDBToast
          color="danger"
          defaultOpen
          autohide
          position="top-center"
          appendToBody
          width={400}
          delay={5000}
          headerContent={
            <>
              <strong className="me-auto"><h5>Importing Failed!</h5></strong>
            </>
          }
          bodyContent={importPlanError}
        />
      )}

      {importSlotError && (
        <MDBToast
          color="danger"
          defaultOpen
          autohide
          position="top-center"
          appendToBody
          width={400}
          delay={5000}
          headerContent={
            <>
              <strong className="me-auto"><h5>Importing Failed!</h5></strong>
            </>
          }
          bodyContent={importSlotError}
        />
      )}

      {importAddonError && (
        <MDBToast
          color="danger"
          defaultOpen
          autohide
          position="top-center"
          appendToBody
          width={400}
          delay={5000}
          headerContent={
            <>
              <strong className="me-auto"><h5>Importing Failed!</h5></strong>
            </>
          }
          bodyContent={importAddonError}
        />
      )}
    </>
  );
};

export default PlansAndAddons;